import React from 'react';
import {
    Box,
    Text,
    SimpleGrid,
    useColorModeValue,
    Spinner,
    Flex,
    IconButton,
    Tooltip,
    useToast,
} from '@chakra-ui/react';

// Components
import MiniStatistics from 'components/card/MiniStatistics';
import IconBox from 'components/icons/IconBox';
import Icon from 'components/icons/Icon';

// Icons
import {
    MdGroup,
    MdRefresh,
    MdQrCode,
} from 'react-icons/md';

// Hooks
import { useTrainerDashboard } from '../../../services/useTrainerDashboard';
import BrandingSettings from '../../agency/branding/BrandingSettings';

export default function TrainerDashboard() {
    // Chakra Color Mode
    const brandColor = useColorModeValue('brand.500', 'white');
    const boxBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.100');

    // Dashboard statistics
    const {
        totalClients,
        activeClients,
        trainerCode,
        trainerName,
        isLoading,
        error,
        refreshStats,
    } = useTrainerDashboard();

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
            <Flex justify="space-between" align="center" mb="20px">
                <Text
                    color={useColorModeValue('secondaryGray.900', 'white')}
                    fontSize="2xl"
                    fontWeight="700"
                    lineHeight="100%"
                >

                </Text>
                <Tooltip label="Refresh Statistics">
                    <IconButton
                        aria-label="Refresh statistics"
                        icon={isLoading ? <Spinner size="sm" /> : <Icon as={MdRefresh} />}
                        variant="outline"
                        onClick={refreshStats}
                        isLoading={isLoading}
                        size="sm"
                    />
                </Tooltip>
            </Flex>

            <SimpleGrid
                columns={{ base: 1, md: 2, lg: 3, '2xl': 3 }}
                gap="20px"
                mb="20px"
            >
                <MiniStatistics
                    startContent={
                        <IconBox
                            w="56px"
                            h="56px"
                            bg={boxBg}
                            icon={
                                <Icon width="32px" height="32px" as={MdGroup} color={brandColor} />
                            }
                        />
                    }
                    name="Total Clients"
                    value={isLoading ? '-' : totalClients.toString()}
                />
                <MiniStatistics
                    startContent={
                        <IconBox
                            w="56px"
                            h="56px"
                            bg={boxBg}
                            icon={
                                <Icon width="32px" height="32px" as={MdGroup} color={brandColor} />
                            }
                        />
                    }
                    name="Active Clients"
                    value={isLoading ? '-' : activeClients.toString()}
                />
                <MiniStatistics
                    startContent={
                        <IconBox
                            w="56px"
                            h="56px"
                            bg={boxBg}
                            icon={
                                <Icon width="32px" height="32px" as={MdQrCode} color={brandColor} />
                            }
                        />
                    }
                    name="Trainer Code"
                    value={isLoading ? '-' : trainerCode || 'N/A'}
                />
            </SimpleGrid>

            {error && (
                <Box
                    p="20px"
                    bg={useColorModeValue('red.50', 'red.900')}
                    borderRadius="20px"
                    mb="20px"
                    border="1px solid"
                    borderColor={useColorModeValue('red.200', 'red.700')}
                >
                    <Text color={useColorModeValue('red.600', 'red.200')} fontWeight="medium">
                        Error loading dashboard statistics: {error}
                    </Text>
                </Box>
            )}

            <BrandingSettings context="trainer" />
        </Box>
    );
}
